export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://backend:5555';

// If you need to use it in a React component, you can also export it like this:
export const APIConfig = {
  BASE_URL: import.meta.env.VITE_API_URL || 'http://backend:5555'
};